<app-intermission
  *ngIf="showIntermission"
  [label]="'Continue'"
  (onContinue)="stopIntermission()"
></app-intermission>

<div
  *ngIf="!showIntermission"
  class="app-container vw-100 vh-100 d-flex align-items-center justify-content-center"
>
  <div *ngIf="!isVisible">
    <svg
      class="app-focus-marker"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
      />
    </svg>
  </div>

  <div
    *ngIf="isVisible"
    class="d-flex align-items-center justify-content-center"
  >
    <div class="app-category-container d-flex justify-content-between w-100">
      <div class="d-flex flex-column align-items-center">
        <div>
          <strong>{{ decisionKeys[0].toUpperCase() }}:</strong>
        </div>
        <div class="mt-1">
          <strong>{{ category[0] }}</strong>
        </div>
        <div class="mt-1">
          <strong>{{ category[1] }}</strong>
        </div>
      </div>
      <div class="d-flex flex-column align-items-center">
        <div>
          <strong>{{ decisionKeys[1].toUpperCase() }}</strong
          >:
        </div>
        <div class="mt-1">
          <strong>{{ category[2] }}</strong>
        </div>
        <div class="mt-1">
          <strong>{{ category[3] }}</strong>
        </div>
      </div>
    </div>

    <div
      class="app-word-display d-flex flex-column align-items-center justify-content-center"
      *ngIf="!finishedTrial"
    >
      <!-- ngFor is needed in order to show the fade out for every word -->
      <div class="app-word-container" *ngIf="mode !== 'reading'">
        <div
          *ngFor="let need of [stimuli[id]]"
          [ngClass]="{ visible: isVisible, invisible: !isVisible }"
          [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
          (onKeypress)="checkAnswerAndLoadNextItem($event)"
        >
          <div *ngIf="!getIsImage(stimuli[id].value)">
            {{ stimuli[id].value }}
          </div>
          <img
            *ngIf="getIsImage(stimuli[id].value)"
            class="app-stimuli-img img-fluid shadow"
            [src]="getImageFilePath(stimuli[id].value)"
          />
        </div>
      </div>

      <div class="app-word-container" *ngIf="mode === 'reading'">
        <div
          *ngFor="let need of [stimuli[id]]"
          [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
          (onKeypress)="checkAnswerAndLoadNextItem($event)"
        >
          <div *ngIf="!getIsImage(stimuli[id].value)">
            {{ stimuli[id].value }}
          </div>
          <img
            *ngIf="getIsImage(stimuli[id].value)"
            class="img-fluid"
            [src]="getImageFilePath(stimuli[id].value)"
          />
        </div>
      </div>
    </div>

    <div
      class="app-wrong-decision-container d-flex flex-column align-items-center justify-content-center"
    >
      <svg
        *ngIf="!answerCorrect"
        class="app-wrongDecisionMarker"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
      <div
        class="text-wrong-decision d-flex flex-column align-items-center"
        [innerHTML]="instructionWrongButtonPress"
      ></div>
    </div>
  </div>
</div>
